import { deleteDeveloper } from "../../developer/services/developerApi";
import { deleteAllDocuments } from "../../media/services/mediaApi";

export const cleanupAll = async ({ merchantDocs, business, businessDocs }) => {
    try {
        const fileNames = [];

        if (merchantDocs?.merchantRecto && typeof merchantDocs.merchantRecto === "string") {
            fileNames.push(merchantDocs.merchantRecto);
        }

        if (merchantDocs?.merchantVerso && typeof merchantDocs.merchantVerso === "string") {
            fileNames.push(merchantDocs.merchantVerso);
        }

        if (merchantDocs?.RIB && typeof merchantDocs.RIB === "string") {
            fileNames.push(merchantDocs.RIB);
        }

        if (merchantDocs?.Domicile && typeof merchantDocs.Domicile === "string") {
            fileNames.push(merchantDocs.Domicile);
        }

        if (Array.isArray(businessDocs?.fileNames)) {
            fileNames.push(...businessDocs.fileNames);
        }

        if (fileNames.length > 0) {
            await deleteAllDocuments({ fileNames });
        }

        if (business?.id) {
            await deleteDeveloper(business.id);
        }

    } catch (e) {
        console.error("Cleanup error", e);
    }
};